import './Exit.scss';
import React, { FC } from 'react';
import SafeLink from '@/components/extra/SafeLink/SafeLink';
import { serviceItems } from '@/components/page/page-registry';
import type { IconType } from '@/components/extra/Icon/Icon';
import ButtonIcon from '@/components/basic/ButtonIcon/ButtonIcon';

type ExitProps = Record<string, never>;

const Exit: FC<ExitProps> = () => {
    return (
        <footer className="Exit">
            <nav className="Exit_nav" aria-label="Fußzeile">
                <ul className="Exit_list">
                    <li>
                        <SafeLink to="/" className="Exit_link">
                            <ButtonIcon icon={'home' as IconType} />
                            <span className="Exit_title">Startseite</span>
                        </SafeLink>
                    </li>
                    <li>
                        <SafeLink to="/sitemap" className="Exit_link">
                            <ButtonIcon icon={'sitemap' as IconType} />
                            <span className="Exit_title">
                                Inhaltsverzeichnis
                            </span>
                        </SafeLink>
                    </li>
                    {serviceItems
                        .filter((item) => item.path !== 'sitemap')
                        .map((item) => (
                            <li key={item.path}>
                                <SafeLink to={item.path} className="Exit_link">
                                    <ButtonIcon icon={item.icon as IconType} />
                                    <span className="Exit_title">
                                        {item.title}
                                    </span>
                                </SafeLink>
                            </li>
                        ))}
                </ul>
            </nav>
            <p className="Exit_copy">&copy; 2026 Wir wollen Wiesen</p>
        </footer>
    );
};

export default Exit;
